import type { AnswerWidgets } from '@openx/components-core/lib/AiChat/answerWidgets';
import { Markdown } from '@openx/components-core/lib/Markdown/Markdown';
import { renderOpenXAgentAnswerWidget } from '../../AnswerWidgets/openXAgentAnswerWidgets';
import { MESSAGE_FONT_SIZE } from '../utils/consts';

type OpenXAgentMarkdownProps = {
  content: string;
  widgets?: AnswerWidgets | undefined;
};

export const OpenXAgentMarkdown = ({ content, widgets }: OpenXAgentMarkdownProps) => (
  <Markdown
    content={content}
    fontSize={MESSAGE_FONT_SIZE}
    widgets={widgets}
    renderWidget={renderOpenXAgentAnswerWidget}
  />
);
